
import { defineComponent } from 'vue';
import HeadBar from '@/components/Common/HeadBar.vue';
export default defineComponent({
  name: 'Entrance',
  components: { HeadBar },
});
